class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.delay = this.dataset.delay || 500;

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    if (this.dataset.open == 'hover') {
      this.toggleOnHover();
    }
  }

  toggleOnHover() {
    let closeTimeout;
  
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      this.open();
    });
  
    this.mainDetailsToggle.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => this.close(), this.delay);
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
